module.exports = __webpack_public_path__ + "img/datacenter4.d627f6d9.png";